import script from "./DynamicDocRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicDocRenderer.vue?vue&type=script&setup=true&lang=js"

import "./DynamicDocRenderer.vue?vue&type=style&index=0&id=2aafad73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aafad73"]])

export default __exports__